import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsArchiveofourownComponent } from './simple-icons-archiveofourown.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsArchiveofourownComponent ],
    exports:      [ SimpleIconsArchiveofourownComponent ],
    bootstrap:    []
})
export class SimpleIconsArchiveofourownModule {}
